module.exports = __webpack_public_path__ + "media/images/favicon_image-803f9fc2731dde5eb49053d58af59034.png";